import React from "react";

const Signature = ({ label }) => {
  return (
    <div style={wrapper}>
      {label ? (
        <h6 style={textBold}>{`${label} Signature _______________________`}</h6>
      ) : (
        <h6 style={textBold}>{`Signature _______________________`}</h6>
      )}
    </div>
  );
};

const wrapper = {
  marginTop: "40px",
};

const textBold = {
  fontWeight: "bold",
  fontSize: "15px",
};

export default Signature;
